export default {
    data() {
        return {
            statusOptions: [
                { value: '0', label: '等待支付' },
                { value: '1', label: '支付成功' },
                { value: '2', label: '部分退款' },
                { value: '3', label: '全部退款' },
                { value: '4', label: '已发货' },
                { value: '5', label: '交易成功' },
                { value: '6', label: '退款中' }
            ]
        };
    },
    methods: {
        productTypeLabel(v) {
            if (v === 1 || v === '1') return 'VIP';
            if (v === 2 || v === '2') return 'SVIP';
            if (v === 3 || v === '3') return 'BVIP';
            return '';
        },
        buyDateTypeLabel(v) {
            if (v === 1 || v === '1') return '半年';
            if (v === 2 || v === '2') return '包年';
            return '';
        },
        formatProduct(row) {
            if (!row) return '';
            const pt = row.productType;
            const typeLabel = this.productTypeLabel(pt);
            let result = '';
            if (pt === 3 || pt === '3') {
                const count = row.count != null && row.count !== '' ? row.count : 0;
                result = typeLabel + '-' + count + '枚';
            } else {
                const buyLabel = this.buyDateTypeLabel(row.buyDateType);
                if (typeLabel && buyLabel) {
                    result = typeLabel + '-' + buyLabel;
                } else {
                    result = typeLabel || buyLabel || '';
                }
            }
            if (row.cardNo != null && row.cardNo !== '') {
                result = result ? result + ' 卡号:' + row.cardNo : '卡号:' + row.cardNo;
            }
            return result;
        },
        statusLabel(v) {
            const item = this.statusOptions.find((o) => o.value === String(v));
            return item ? item.label : (v != null && v !== '' ? String(v) : '');
        },
        formatAmount(v) {
            if (v === null || v === undefined || v === '') {
                return '';
            }
            const n = parseFloat(v);
            if (isNaN(n)) {
                return v;
            }
            if (Math.floor(n) === n) {
                return String(parseInt(n, 10));
            }
            return String(n);
        },
        formatGmtCreate(val) {
            if (this.$util.isEmpty(val)) {
                return '';
            }
            return this.$commonFn.formatDate(val, 'Y-M-D H:I:S');
        },
        payTypeLabel(v) {
            if (v === 'wx') return '微信支付';
            if (v === 'alipay') return '支付宝支付';
            return v != null && v !== '' ? String(v) : '';
        },
        expressTypeLabel(v) {
            if (v === 1 || v === '1') return '寄学校';
            if (v === 2 || v === '2') return '寄家里';
            return '';
        },
        badgeAvatarLabel(v) {
            if (v === 0 || v === '0') return '无';
            if (v === 1 || v === '1') return '有';
            return '';
        },
        deleteSignLabel(v) {
            if (v === 0 || v === '0') return '正常';
            if (v === 1 || v === '1') return '已删除';
            return '';
        },
        formatPrivilege(val) {
            if (this.$util.isEmpty(val)) {
                return '';
            }
            try {
                const arr = JSON.parse(val);
                if (Array.isArray(arr)) {
                    return arr.map((item) => {
                        const name = item.projectName || item.project || '';
                        const priv = item.PRIVILEGE || item.privilege || '';
                        return name ? (name + (priv ? '：' + priv : '')) : priv;
                    }).filter(Boolean).join('；');
                }
            } catch (e) {
                /* ignore */
            }
            return String(val);
        },
        displayVal(val) {
            if (val === null || val === undefined || val === '') {
                return '-';
            }
            return val;
        },
        toTimestamp(val) {
            if (this.$util.isEmpty(val)) {
                return '';
            }
            if (typeof val === 'number') {
                return val;
            }
            if (typeof val === 'string') {
                if (/^[0-9]+$/.test(val)) {
                    return parseInt(val, 10);
                }
                const t = new Date(val.replace(new RegExp(/-/gm), '/')).getTime();
                return isNaN(t) ? '' : t;
            }
            const t = new Date(val).getTime();
            return isNaN(t) ? '' : t;
        },
        /** 转为秒级时间戳（日期选择器 timestamp 一般为毫秒） */
        toSecondTimestamp(val) {
            const ts = this.toTimestamp(val);
            if (ts === '' || ts == null) {
                return '';
            }
            const n = Number(ts);
            if (isNaN(n)) {
                return '';
            }
            if (n > 9999999999) {
                return Math.floor(n / 1000);
            }
            return Math.floor(n);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/page/member/order/memberOrderMixin.js